<div class="eds-white pad30" [dir]="textDir">
  <label class="title mrT10">{{'Review & complete' | translate}}</label>
    <div class="sm-12 marT30 flexStart" >
        <label class="left sm-3 label-light">{{'Project Name' | translate}}</label>
        <div class="sm-6 marT5 labeltxt">
          {{this.myFormGroup.get('name').value}}
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="sm-12 marT20 flexStart" >
      <label class="left sm-3 label-light">{{'Description' |translate}}</label>
      <div class="sm-6 marT5 labeltxt">
      
          {{this.myFormGroup.get('description').value}}
        
      </div>
  </div>
  <div class="clearfix"></div>

    <div class="sm-12 marT20 flexStart">
        <label class="left sm-3 label-light">{{'Lead partner' | translate}}</label>
        <div class="sm-6 marT5 labeltxt">
          {{this.myFormGroup.get('lpartner').value?.name}}
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="form-group sm-12 marT20 flexStart">
        <label class="left sm-3 label-light">{{'Country' |translate}}</label>
        <div class="sm-6 marT5 labeltxt">
          {{this.myFormGroup.get('country').value?.name}}
        </div>
    </div>
    <div class="clearfix"></div>

    <div class="sm-12 marT20 item-middle">
      <div class="sm-3">
        <label class="label-light" for="Project Logo">
          {{'Logo' |translate}}
        </label>
      </div>
      <div class="sm-4 marT5">
        <img *ngIf="this.myFormGroup.get('logo').value?.url" class="round" alt="" [src]="this.myFormGroup.get('logo').value?.url?.replace('<FILEBASEURL>', environment.msdpAPIBaseURL)">
      </div>
     
  </div>

  <div class="h-line marT20">
    
  </div>




    <div class="sm-12 marT20 ">
    <label class="sm-7 title">{{'Lead project admin details' |translate}}</label>
    </div>
    <div class="clearfix"></div>
    <div class="sm-12 marT15 flexStart">
        <label class="left sm-3 label-light">{{'First names' | translate}}</label>
        <div class="sm-6 marT5 labeltxt">
          {{this.myFormGroup.get('admin.first_name').value}}          
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="sm-12 marT15 flexStart">
      <label class="left sm-3 label-light">{{'Surname' | translate}}</label>
      <div class="sm-6 marT5 labeltxt">      
        {{this.myFormGroup.get('admin.last_name').value}}
      </div>
  </div>
  <div class="clearfix"></div>
    <div class="sm-12 marT15 flexStart" >
        <label class="left sm-3 label-light">{{'Email address' | translate}}</label>
        <div class="sm-6 marT5 labeltxt">
          {{this.myFormGroup.get('admin.email').value}}
        </div>
    </div>
    <div class="marB100"></div>
</div>
